//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiBellOutline } from '@mdi/js'

export default {
  setup() {
    return {
      icons: { mdiBellOutline },
    }
  },
}
